import styled from "styled-components";
import { Input } from "../../components/input/Input";
import { Spacer } from "./Spacer";
import { TextCapitalized } from "./text/TextCapitalized";

interface HourMinuteInputProps {
  hours: string;
  setHours: (value: string) => void;
  minutes: string;
  setMinutes: (value: string) => void;
  error?: boolean;
}

const formatTimeUnit = (raw: string, max: number) => {
  const digits = raw.replace(/\D/g, "").slice(-2);
  if (digits === "") return "";
  return String(Math.min(Number(digits), max)).padStart(2, "0");
};

export const HourMinuteInput = (props: HourMinuteInputProps) => {
  return (
    <StyledContainer>
      <Input
        value={props.hours}
        onChange={(e) => props.setHours(formatTimeUnit(e.target.value, 23))}
        type="text"
        inputMode="numeric"
        noneBottomSpacer
        error={props.error ? "" : undefined}
      />
      <Spacer x={1} />
      <TextCapitalized>:</TextCapitalized>
      <Spacer x={1} />
      <Input
        value={props.minutes}
        onChange={(e) => props.setMinutes(formatTimeUnit(e.target.value, 59))}
        type="text"
        inputMode="numeric"
        noneBottomSpacer
        error={props.error ? "" : undefined}
      />
    </StyledContainer>
  );
};

const StyledContainer = styled.div`
  display: flex;
  align-items: center;
`;
